/* globals MR, braintree, OffAmazonPayments */

<template lang="pug">
  .cart-select-payment-method-modal.text-center
    p.title-text.color-slate.xs-f-small.max-at-tweak Please select your payment method:
    button.mr-btn.font-small.max-at-tweak(@click="checkoutWithCC" data-mr-ass="checkout-with-cc")
      i.card-logo
      |  Credit Card
    button.mr-btn.paypal-button.font-small.max-at-tweak(@click="checkoutWithPaypal" aria-label="Paypal")
    button#AmazonPayButton.btn-reset.block(aria-label="Amazon Pay")

</template>

<script>
  import { mapActions } from 'vuex';
  import { getClientToken, updatePaypalInfo } from '../../../services/vuePaymentSvc';

  export default {
    name: "CartSelectPaymentMethod",

    data() {
      return {
        paypalCheckout: null
      }
    },

    methods: {
      ...mapActions(['notifyError']),

      checkoutWithCC() {
        this.trackEvent('Payment Selected', { type: 'Credit Card' });
        window.location.href = '/checkout';
      },

      checkoutWithPaypal() {
        if (!this.paypalCheckout) {
          return;
        }
        this.$emit('hide-modal');
        this.paypalCheckout.paypal.initAuthFlow();
      },

      initPaypalButton() {
        var self = this;

        if (braintree) {
          getClientToken().then((res) => {
            braintree.setup(res.data.clientToken, 'custom', {
              paypal: {
                singleUse: false,
                enableShippingAddress: true,
                headless: true
              },

              onReady: (integration) => {
                self.paypalCheckout = integration;
              },

              dataCollector: {
                kount: { environment: MR.config.braintreeEnvironment },
                paypal: true,
              },

              onPaymentMethodReceived: (res) => {
                self.trackEvent('Payment Selected', { type: 'PayPal' });

                updatePaypalInfo(res).then((updateRes) => {
                  dataLayer.push({
                    'event': 'AddPaymentInfo',
                    'paymentType': 'paypal'
                  });
                  window.location.href = '/checkout?type=paypal';
                }).catch((err) => {
                  self.$emit('hide-modal');

                  if (err.data) {
                    switch (err.data.code) {
                      case "USER_ALREADY_EXISTS":
                        if (err.data.errorDetails) {
                          email = (err.data.errorDetails[0] || {}).email;
                        }

                        self.$root.signInControl.open = true;
                        return;

                      case "ONLY_US_ADDRESS":
                        this.notifyError('We were unable to process your payment method. Please review your information or call us at ' + MR.config.contactPhone);
                        return;
                    }
                  }

                  this.notifyError('We were unable to process your payment method. Please review your information or call us at ' + MR.config.contactPhone);
                });
              }
            });
          });
        }
      },

      initAmazonButton() {
        var self = this;
        if (OffAmazonPayments) {
          OffAmazonPayments.Button('AmazonPayButton', MR.config.amazonSellerId, {
            type: "PwA",
            color: "LightGray",
            size: "large",
            authorization: () => {
              var loginOptions = {
                scope: 'profile postal_code payments:widget payments:shipping_address payments:autopay_consent',
                popup: false
              };
              self.trackEvent("Amazon Pay Clicked");
              document.cookie = 'amazon_redirect=/checkout?type=amazon;';
              self.trackEvent('Payment Selected', { type: 'Amazon' });
              amazon.Login.authorize(loginOptions, '/amazonLogin');
            }
          });
        }
      }
    },

    mounted() {
      this.initPaypalButton();
      this.initAmazonButton();
    }
   }
</script>

<style scoped lang="stylus">
  .cart-select-payment-method-modal
    .title-text
      padding-bottom 1em

    .mr-btn
    #AmazonPayButton
      display block
      margin 0 auto
      margin-bottom 1em
      width 300px

    .paypal-button
      background-color color-gray-light
      background-image url("/images/checkout-flow/paypal.svg")
      background-repeat no-repeat
      background-position center
      border 1px solid color-fog
      height 3.5em

    @media mq-mobile
      .title-text
        padding-top 1.5em

</style>
